var m = Object.defineProperty;
var f = (i, t, e) => t in i ? m(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e;
var r = (i, t, e) => (f(i, typeof t != "symbol" ? t + "" : t, e), e);
import a from "store/dist/store.modern";
function d(i) {
  return typeof i < "u" && i !== null && i !== "";
}
function g() {
  return Date.now();
}
function x(i) {
  return i + "-xxxxxxxx-".replace(/[x]/g, function(t) {
    const e = Math.random() * 36 | 0;
    return (t == "x" ? e : e & 3 | 8).toString(36);
  }) + g().toString(36);
}
function c(i, t) {
  return d(i) ? typeof i == "object" ? c(JSON.stringify(i)) : typeof i == "function" ? c(i(...t ?? [])) : String(i) : "";
}
function p() {
  const i = navigator.userAgent;
  let t, e = i.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ?? [];
  return /trident/i.test(e[1]) ? (t = /\brv[ :]+(\d+)/g.exec(i) ?? [], "IE " + (t[1] || "")) : e[1] === "Chrome" && (t = i.match(/\b(OPR|Edge)\/(\d+)/), t != null) ? t.slice(1).join(" ").replace("OPR", "Opera") : (e = e[2] ? [e[1], e[2]] : [navigator.appName, navigator.appVersion, "-?"], (t = i.match(/version\/(\d+)/i)) != null && e.splice(1, 1, t[1]), e.join(" "));
}
function w() {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0 || // @ts-expect-error this is a backwards compatibility thing which TS doesn't like
  navigator.msMaxTouchPoints > 0;
}
function v() {
  return window.navigator.userAgent;
}
const h = [
  "utm_source",
  "utm_medium",
  "utm_term",
  "utm_content",
  "utm_campaign",
  "utm_source_platform",
  "utm_creative_format",
  "utm_marketing_tactic"
];
class y {
  constructor(t) {
    this.prefix = t;
  }
  key(t) {
    return `${this.prefix}${t}`;
  }
  /**
   * Set a value in the store
   *
   * Note: this used to take a minutes parameter, but it was not supported
   * by the store library. If we need to support this, we will need to
   * use a different library or wrap the objects with some timestamps
   * and do the expiration ourselves.
   *
   * @param name
   * @param value
   */
  set(t, e) {
    a.set(this.key(t), e);
  }
  /**
   * Get a value from the store
   *
   * @param name
   */
  get(t) {
    return a.get(this.key(t));
  }
  /**
   * Delete a value from the store
   *
   * @param name
   */
  delete(t) {
    a.remove(this.key(t));
  }
  /**
   * Check if a value exists in the store
   *
   * @param name
   */
  exists(t) {
    return d(this.get(t));
  }
  // TODO: this is bad and is why we see the wrong UTMs on other websites
  // we need to not do this in the store and just keep references in the
  // main class
  // this function could be useful though.
  setUtms() {
    const t = new URL(window.location.href), e = {};
    for (const s of h) {
      const n = t.searchParams.get(s);
      d(n) && (e[s] = n);
    }
    this.set("utm", JSON.stringify(e));
  }
  getUtm(t) {
    if (this.exists("utm")) {
      const e = JSON.parse(this.get("utm"));
      return t in e ? e[t] : "";
    }
    return "";
  }
}
class _ {
  constructor(t) {
    r(this, "beaconURL");
    r(this, "id");
    r(this, "params", {});
    r(this, "prefix", "pixel-");
    r(this, "transport");
    r(this, "version", "0.1.0");
    r(this, "store");
    r(this, "uid");
    r(this, "exclude", []);
    r(this, "include", []);
    r(this, "excludeEmptyAttributes", !1);
    this.beaconURL = t.beaconURL, this.id = t.id, this.prefix = t.prefix ?? this.prefix, this.version = t.version ?? this.version, this.params = t.params ?? this.params, this.transport = t.transport, this.uid = t.uid, this.exclude = t.exclude ?? this.exclude, this.include = t.include ?? this.include, this.excludeEmptyAttributes = t.excludeEmptyAttributes ?? this.excludeEmptyAttributes, this.store = new y(this.prefix), this.init();
  }
  init() {
    this.store.exists("uid") || this.store.set("uid", this.uid ?? x(this.version)), this.uid = this.uid ?? this.store.get("uid"), this.store.setUtms();
  }
  /**
   * Get all attributes to send with the event
   *
   * @param opts
   */
  getAttributes(t) {
    const e = h.reduce((n, o) => (n[o] = (u) => this.store.getUtm(u), n), {}), s = {
      id: () => this.id,
      // website Id
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      uid: () => this.uid,
      // user Id
      ev: () => t.event,
      // event being triggered
      ed: () => c(t.data),
      // any event data to pass along
      v: () => this.version,
      // openpixel.js version
      dl: () => window.location.href,
      // document location
      rl: () => document.referrer,
      // referrer location
      ts: () => c(t.timestamp),
      // timestamp when event was triggered
      de: () => document.characterSet,
      // document encoding
      sr: () => window.screen.width + "x" + window.screen.height,
      // screen resolution
      vp: () => window.innerWidth + "x" + window.innerHeight,
      // viewport size
      cd: () => c(window.screen.colorDepth),
      // color depth
      dt: () => document.title,
      // document title
      bn: () => p(),
      // browser name and version number
      md: () => c(w()),
      // is a mobile device?
      ua: () => v(),
      // user agent
      tz: () => c((/* @__PURE__ */ new Date()).getTimezoneOffset()),
      // timezone
      ...e,
      ...this.params
    };
    for (const n of Object.keys(s)) {
      let o = !1;
      this.exclude.length > 0 && this.exclude.includes(n) && (o = !0), this.include.length > 0 && !this.include.includes(n) && (o = !0), o && delete s[n];
    }
    return s;
  }
  /**
   * Build the url to send the pixel to
   *
   * @param opts
   */
  buildUrl(t) {
    const e = new URL(this.beaconURL), s = this.getAttributes(t);
    for (const [n, o] of Object.entries(s)) {
      const u = c(o, [n]);
      this.excludeEmptyAttributes && u === "" || e.searchParams.set(n, u);
    }
    return e;
  }
  /**
   * Send the pixel
   *
   * @param event - event name
   * @param data - event data
   * @param timestamp - event timestamp (defaults to Date.now())
   */
  async send(t, e, s) {
    const n = this.buildUrl({
      event: t,
      timestamp: s ?? Date.now(),
      data: e
    }).toString();
    this.transport === "image" ? await this.sendImage(n) : this.transport === "beacon" ? this.sendBeacon(n) : window.navigator.sendBeacon ? this.sendBeacon(n) : await this.sendImage(n);
  }
  /**
   * Send the pixel using the beacon transport
   *
   * @param url
   */
  sendBeacon(t) {
    window.navigator.sendBeacon(t);
  }
  /**
   * Send the pixel using the image transport
   *
   * @param url
   */
  async sendImage(t) {
    const e = document.createElement("img");
    e.src = t, e.style.display = "none", e.style.visibility = "hidden", e.style.position = "absolute", e.style.width = "1", e.style.height = "1";
    let s, n;
    const o = new Promise((u, l) => {
      s = u, n = l;
    });
    return e.addEventListener("load", () => {
      e.remove(), s();
    }), e.addEventListener("error", (u) => {
      e.remove(), n(u);
    }), document.body.appendChild(e), await o;
  }
}
export {
  _ as Pixel
};
